import React from "react";
import jwt_decode from "jwt-decode";
import "devextreme/data/odata/store";
import { createStore } from "devextreme-aspnet-data-nojquery";
import plusimg from "../../images/common/plus.png";
import exportimg from "../../images/common/xlsx.png";
import deleteBlue from "../../images/common/deleteBlue.png";
import deleteimg from "../../images/common/delete.png";
import editimg from "../../images/common/pencil.png";
import history from "../history";
import { Form, Row, Modal, Button as ButtonBootstrap } from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { exportToExcel } from '../../utils/exportMethods';
import MultiSelectDropdown from "./pages/customComponents/MultiSelectDropdown";
import "../../css/Buttons.css";
import { config } from "../../constants";
import CircleSign from "../ui/CircleSign";
import { deleteKey } from "../../utils/exportMethods";
import Maximize from "../ui/Maximize";
import Minimize from "../ui/Minimize";
import ConfirmationModal from "../ui/ConfirmationModal";
import ConfirmationDelete from "../ui/ConfirmationDelete";
import CustomDataGrid from "./pages/customComponents/CustomDataGrid";
import apiClient from '../../utils/apiClient';
import { handleErrorResponse } from '../../utils/apiClient';
import { StatusCodes, getReasonPhrase } from "http-status-codes";

const url = config.url.URL;
const profileLoadUrl = `${url}/ProfileMicroservice`;
const RefCriteriaLoadUrl = `${url}/CriteriasMicroservice/GetUserCriteriaValues`

const dataSource = createStore({
  key: "scopeId",
  loadUrl: profileLoadUrl,
  onBeforeSend: (method, ajaxOptions) => {
    ajaxOptions.headers = {
      'accept': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    }
  },
  onAjaxError: (e) => {
    const { xhr, error } = e;
    handleErrorResponse(error || { message: 'Unknown error occurred.', response: xhr });
  }
});

const appName = ""; ///ArchicubedWeb"; //Production
const LoadSubmenu = (section) => {
  history.push(appName + "/admin" + (section !== "" ? "/" + section : ""));
};

const exportProfilesToExcel = async (apiData) => {
  apiData.forEach((obj) => {
    deleteKey(obj, "scopeId");
  });

  const headers = [
    { header: "Name", key: "name", autoFit: true },
    { header: "Agency", key: "agency", width: 50 },
    { header: "Agency Network", key: "agencyNetwork", autoFit: true },
    { header: "Zone", key: "zone", autoFit: true },
    { header: "Subzone", key: "subzone", autoFit: true },
    { header: "Country/Region", key: "country", width: 50 },
    { header: "Division", key: "division", autoFit: true },
    { header: "Media", key: "media", autoFit: true },
  ];

  await exportToExcel(headers, apiData, 'profiles_extract', 'Profiles Extract');
};


class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.applyFilterTypes = [
      {
        key: "auto",
        name: "Immediately",
      },
      {
        key: "onClick",
        name: "On Button Click",
      },
    ];

    this.state = {
      showFilterRow: true,
      showHeaderFilter: false,
      currentFilter: this.applyFilterTypes[0].key,
      showColumnLines: false,
      showRowLines: true,
      showBorders: true,
      rowAlternationEnabled: true,
      showModal: false,
      showEditModal: false,
      showConfirmationModal: false,
      showConfirmationDelete: false,
      selectedRowIndex: "",
      fullscreen: false,
      selectedFilters: {
        agency: [],
        agencynetwork: [],
        zone: [],
        subzone: [],
        country: [],
        maison: [],
        division: [],
        media: [],
        currency: [],
      },
      showUserMenu: true,
      showProfileMenu: true,
      showRoleMenu: true,
      validation: true,
      editValidation: true,
      duplicatedValidation: true,
      selectedRowName: "",
      selectedId: "",
      selectedName: "",
    };
    this.dataGrid = null;
    this.onShowFilterRowChanged = this.onShowFilterRowChanged.bind(this);
    this.onShowHeaderFilterChanged = this.onShowHeaderFilterChanged.bind(this);
    this.onCurrentFilterChanged = this.onCurrentFilterChanged.bind(this);
    this.isCloneIconVisible = this.isCloneIconVisible.bind(this);
    this.isDisabled = this.isDisabled.bind(this);

    this.profileName = React.createRef();
    this.buyingAgencyRef = React.createRef();
    this.agencyNetworkRef = React.createRef();
    this.countryRef = React.createRef();
    this.currencyRef = React.createRef();
    this.zoneRef = React.createRef();
    this.subzoneRef = React.createRef();
    this.maisonRef = React.createRef();
    this.divisionRef = React.createRef();
    this.mediaRef = React.createRef();
  }

  isCloneIconVisible(e) {
    return !e.row.data.isDeletable;
  }

  isDisabled(e) {
    return e.row.data.isDeletable;
  }

  fullscreenHandler = () => {
    this.setState((prevState) => ({ fullscreen: !prevState.fullscreen }));
  };

  selectedChanged(e) {
    this.setState({
      selectedRowIndex: e.component.getRowIndexByKey(e.selectedRowKeys[0]),
    });
  }

  handleFilterChange = async (filterKey, selectedValues) => {
    // Ensure valuesOnly is an empty array if selectedValues is empty, null, or undefined
    const valuesOnly = selectedValues && selectedValues.length > 0
      ? selectedValues.map(item => item.value)
      : [];

    // Update the state with the new filter values, clearing previous values if needed
    this.setState(prevState => {
      const updatedFilters = {
        ...prevState.selectedFilters,
        [filterKey]: valuesOnly,
      };

      return {
        selectedFilters: updatedFilters,
      };
    });
  };




  // to refresh our datagrid table and close all modals
  useRefresh = () => {
    this.dataGrid.useRefresh();
    this.setState({
      showModal: false,
      showEditModal: false,
      showConfirmationModal: false,
    });
  };

  handleClose = () => {
    this.setState({ showConfirmationModal: true });
  };

  closeConfirmationModal = () => {
    this.setState({ showConfirmationModal: false });
  };

  doubleCloseModals = () => {
    const { state } = this.props.location;
    if (typeof state !== "undefined" && state != null) {
      if (state.showNewPopup) {
        history.push({ pathname: "/admin", state: { showNewPopup: false } });
      }
    }
    this.setState({
      showModal: false,
      showEditModal: false,
      showConfirmationModal: false,
    });
  };

  // Respons for both create and edit modals + delete call
  toastCallback = (response, successMessage) => {
    if (response) {
      if (response.status ===  StatusCodes.BAD_REQUEST || response.statusCode === StatusCodes.BAD_REQUEST) {
        this.setState({ duplicatedValidation: false });
        return;
      } else {
        if (response.status ===  StatusCodes.OK || response.statusCode ===  StatusCodes.OK
        ) {
          toast.success(successMessage);
          this.doubleCloseModals();
          const { state } = this.props.location;
          if (typeof state !== "undefined" && state != null) {
            if (state.showNewPopup) {
              history.push({
                pathname: "/admin",
                state: { showNewPopup: false },
              });
            }
          } else {
            this.useRefresh();
          }
        } else toast.error("Error " + response.status || response.statusCode);
      }
    };
  }

  openModal = () => {
    this.setState({
      showModal: true,
      duplicatedValidation: true,
      validation: true,
      selectedFilters: {
        agency: [],
        agencynetwork: [],
        zone: [],
        subzone: [],
        country: [],
        maison: [],
        division: [],
        media: [],
        currency: [],
      },
    });
  };

  getSelectedValues(ref) {
    const optionsSelected = ref.current?.state.optionsSelected;
    return optionsSelected ? optionsSelected.map(obj => obj.value) : [];
  }

  onCreateProfile = () => {
    let name = this.profileName.current.value.trim();
    this.setState({ duplicatedValidation: true });

    //Inside the getSelectedValues function, it checks if the optionsSelected property of the ref.current.state object is truthy (not null or undefined)

    let buyingAgencies = this.getSelectedValues(this.buyingAgencyRef);
    let agencyNetworks = this.getSelectedValues(this.agencyNetworkRef);
    let zones = this.getSelectedValues(this.zoneRef);
    let subzones = this.getSelectedValues(this.subzoneRef);
    let countries = this.getSelectedValues(this.countryRef);
    let maisons = this.getSelectedValues(this.maisonRef);
    let divisions = this.getSelectedValues(this.divisionRef);
    let medias = this.getSelectedValues(this.mediaRef);
    let currencies = this.getSelectedValues(this.currencyRef);

    let isEnabled = true;

    if (name === "") {
      this.setState({ validation: false });
      return;
    } else {
      this.setState({ validation: true });
    }

    let profile = {
      Name: name,
      ScopeType: "User",
      IsEnabled: isEnabled,
      Accesses: [
        { Table: "Agency", Ids: buyingAgencies },
        { Table: "Agency network", Ids: agencyNetworks },
        { Table: "Zone", Ids: zones },
        { Table: "Sub-zone", Ids: subzones },
        { Table: "Country/Region", Ids: countries },
        { Table: "Maison", Ids: maisons },
        { Table: "Division", Ids: divisions },
        { Table: "Media", Ids: medias },
        { Table: "Currency", Ids: currencies },
      ],
    };

    apiClient.post(profileLoadUrl, profile)
      .then((response) => {
        const data = response.data;
        this.dataGrid.useRefresh();
        let msg = "Profile has been created";
        this.toastCallback(data, msg);
      });
  };

  handleEditClose = () => {
    this.setState({ showConfirmationModal: true });
  };

  groupBy = (xs, key) => {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  showConfirmationDelete = (e) => {
    this.setState({
      showConfirmationDelete: true,
      selectedId: e.row.key,
      selectedName: e.row.data.name,
    });
  };

  hideConfirmationDelete = () => {
    this.setState({ showConfirmationDelete: false });
  };

  onCatchDelete = () => {
    let selectedProfileId = this.state.selectedId;
    apiClient.delete(profileLoadUrl,
      {
        headers: {
          key: selectedProfileId,
        },
      }
    )
      .then((response) => {
        const data = response.data;
        if (data) {
          this.dataGrid.useRefresh();
          let msg = "Profile has been deleted";
          this.toastCallback(data, msg);
          this.hideConfirmationDelete();
        }
      })
  };

  initializeSelectedValues = async () => {
    const { selectedFilters } = this.state;
    const criteriaRefs = {
      agency: this.buyingAgencyRef,
      agencyNetwork: this.agencyNetworkRef,
      zone: this.zoneRef,
      subzone: this.subzoneRef,
      country: this.countryRef,
      maison: this.maisonRef,
      division: this.divisionRef,
      media: this.mediaRef,
      currency: this.currencyRef,
    };
    for (const [criteriaKey, ref] of Object.entries(criteriaRefs)) {
      if (selectedFilters[criteriaKey] && selectedFilters[criteriaKey].length > 0) {
        await this.loadOptionsForCriteria(criteriaKey, ref);
      }
    }
  };

  loadOptionsForCriteria = async (criteriaKey, ref) => {
    const { selectedFilters } = this.state;
    const requestBody = {
        filterJson: JSON.stringify(selectedFilters),
        criteriaKey: criteriaKey
    };

    try {
        const response = await apiClient.post(RefCriteriaLoadUrl, requestBody, {
            headers: {
                "Content-Type": "application/json"
            }
        });

        const criteriaValues = response.data;
        if (ref.current) {
            const selectedIds = selectedFilters[criteriaKey];
            ref.current.setOptions(criteriaValues, selectedIds);
        }
    } catch (error) {
        console.error(`Fetch failed for the Criteria ${criteriaKey}:`, error);
    }
};


  openEditModal = (e) => {
    let selectedProfileId = e.row.key;
    this.setState({
      selectedRowName: e.row.data.name.trim(),
      duplicatedValidation: true,
      editValidation: true,
    });

    apiClient.get(profileLoadUrl.concat("/").concat(selectedProfileId))
      .then((response) => {
        const data = response.data;
        // Retrieve table and id for each access
        let accesses = data.dataAccesses.map(({ criteria, id }) => ({
          criteria,
          id,
        }));

        let accessesByCriteria = [];
        accesses.forEach((item) => {
          if (item.criteria != null) {
            let cri = { table: item.criteria.name, id: item.id };
            accessesByCriteria.push(cri);
          }
        });

        // Group them by table name
        let accessesByTable = this.groupBy(accessesByCriteria, "table");

        // Keep ids for each table
        const selectedFilters = {
          agency: (accessesByTable["Agency"] || []).map(item => item.id),
          agencyNetwork: (accessesByTable["Agency network"] || []).map(item => item.id),
          zone: (accessesByTable["Zone"] || []).map(item => item.id),
          subzone: (accessesByTable["Sub-zone"] || []).map(item => item.id),
          country: (accessesByTable["Country/Region"] || []).map(item => item.id),
          maison: (accessesByTable["Maison"] || []).map(item => item.id),
          division: (accessesByTable["Division"] || []).map(item => item.id),
          media: (accessesByTable["Media"] || []).map(item => item.id),
          currency: (accessesByTable["Currency"] || []).map(item => item.id),
        };

        // Update the state and initialize selected values
        this.setState(
          {
            selectedFilters,
            showEditModal: true,
            selectedRowIndex: selectedProfileId,
          },
          () => {
            // Call initializeSelectedValues after updating the state
            this.initializeSelectedValues();
          }
        );

        // Set the profile name input
        this.profileName.current.value = data.name;
      });
  };


  onEditProfile = () => {
    let scopeId = this.state.selectedRowIndex;
    let name = this.profileName.current.value.trim();
    this.setState({ duplicatedValidation: true });

    //Inside the getSelectedValues function, it checks if the optionsSelected property of the ref.current.state object is truthy (not null or undefined)

    let buyingAgencies = this.getSelectedValues(this.buyingAgencyRef);
    let agencyNetworks = this.getSelectedValues(this.agencyNetworkRef);
    let zones = this.getSelectedValues(this.zoneRef);
    let subzones = this.getSelectedValues(this.subzoneRef);
    let countries = this.getSelectedValues(this.countryRef);
    let maisons = this.getSelectedValues(this.maisonRef);
    let divisions = this.getSelectedValues(this.divisionRef);
    let medias = this.getSelectedValues(this.mediaRef);
    let currencies = this.getSelectedValues(this.currencyRef);

    let isEnabled = true;

    if (name === "") {
      this.setState({ editValidation: false });
      return;
    } else {
      this.setState({ editValidation: true });
    }

    let profile = {
      ScopeId: scopeId,
      Name: name,
      ScopeType: "User",
      IsEnabled: isEnabled,
      Accesses: [
        { Table: "Agency", Ids: buyingAgencies },
        { Table: "Agency network", Ids: agencyNetworks },
        { Table: "Zone", Ids: zones },
        { Table: "Sub-zone", Ids: subzones },
        { Table: "Country/Region", Ids: countries },
        { Table: "Maison", Ids: maisons },
        { Table: "Division", Ids: divisions },
        { Table: "Media", Ids: medias },
        { Table: "Currency", Ids: currencies },
      ],
    };

    apiClient.put(profileLoadUrl, profile)
      .then((response) => {
        const data = response.data;
        this.dataGrid.useRefresh();
        let msg = "Profile has been updated";
        this.toastCallback(data, msg);
      });
  };

  onExportToExcel = () => {
    apiClient.get(`${url}/ProfileMicroservice/Export`)
      .then((response) => {
        if (response) {
          const data = response.data;
          exportProfilesToExcel(data);
          toast.success("Profiles Excel export file has been generated");
        }
      });
  };

  componentDidMount() {
    const decoded = jwt_decode(localStorage.getItem("token"));
    this.setState({
      showUserMenu: decoded.can_manage_users === "true",
      showProfileMenu: decoded.can_manage_profiles === "true",
      showRoleMenu: decoded.can_manage_roles === "true",
      can_export_to_excel: decoded.can_export_to_excel === "true",
    });
    const { state } = this.props.location;
    if (typeof state !== "undefined" && state != null) {
      if (state.showNewPopup) {
        this.setState({ showModal: true });
      }
    }
  }

  render() {
    let countries = this.state.currentCountryIds;

    const columns = [
      { dataField: "name", caption: "Name", width: "100%" },
      // Add other columns specific to Profiles component
    ];

    const buttonColumn = [
      { text: "Edit", icon: editimg, className: "img-grid", name: "edit", onClick: this.openEditModal },
      { text: "Delete", icon: deleteBlue, style: { paddingTop: "-2rem" }, visible: this.isCloneIconVisible, name: "delete", onClick: this.showConfirmationDelete },
      {
        text: "Delete", icon: deleteimg, style: { paddingTop: "-2rem" }, visible: this.isDisabled,
        name: "delete", disabled: true, onClick: null
      },
      // Additional buttons for Profiles component
    ];

    return (
      <div className="div-body-section-details">
        <div className="div-body-section-details-header">
          <div className="div-section-title">
            <span>Profiles Management</span>
          </div>
          <div className="div-section-actions push">
            <button
              className={
                this.state.can_export_to_excel
                  ? "btn-section-header"
                  : "btn-section-header hidden"
              }
              onClick={this.onExportToExcel}
            >
              <img className="img-section-header" src={exportimg} alt={"export"} />
              <label>Export To Excel</label>
            </button>
            <button className="btn-section-header" onClick={this.openModal}>
              <img className="img-section-header" src={plusimg} />
              <label>New Profile</label>
            </button>
          </div>
        </div>
        <div className="div-body-section-details-body">
          <div className="div-body-submenu">
            <div
              className={
                this.state.showUserMenu
                  ? "div-submenu-link"
                  : "div-submenu-link hidden"
              }
              onClick={() => LoadSubmenu("useradministration")}
            >
              <div class="div-submenu-label">
                <label>Users</label>
              </div>
            </div>
            <div
              className={
                this.state.showProfileMenu
                  ? "div-submenu-link active"
                  : "div-submenu-link hidden"
              }
              onClick={() => LoadSubmenu("profiles")}
            >
              <div class="div-submenu-label">
                <label>Profiles</label>
              </div>
            </div>
            <div
              className={
                this.state.showRoleMenu
                  ? "div-submenu-link"
                  : "div-submenu-link hidden"
              }
              onClick={() => LoadSubmenu("roles")}
            >
              <div class="div-submenu-label">
                <label>Roles</label>
              </div>
            </div>
          </div>
          <div className="div-padding-20 div-grid-result">
            <CustomDataGrid
              dataSource={dataSource}
              keyExpr="profileId"
              ref={(ref) => (this.dataGrid = ref)}
              rowAlternationEnabled={this.state.rowAlternationEnabled}
              showFilterRow={this.state.showFilterRow}
              currentFilter={this.state.currentFilter}
              showHeaderFilter={this.state.showHeaderFilter}
              columns={columns}
              buttonColumn={buttonColumn}
            />
          </div>
        </div>
        <ToastContainer position="bottom-right" />

        <ConfirmationDelete
          show={this.state.showConfirmationDelete}
          hide={this.hideConfirmationDelete}
          confirm={this.onCatchDelete}
          title="Delete Profile"
          msg="Are you sure you want to delete this profile ?"
        />

        <Modal
          show={this.state.showModal}
          onHide={this.handleClose}
          size="profiles"
          centered
          fullscreen={this.state.fullscreen}

        >
          <Modal.Header closeButton>
            <Modal.Title size="h6">New Profile</Modal.Title>
            <button
              type="button"
              class="btn btn-primary admin-btn"
              onClick={this.fullscreenHandler}
            >
              {this.state.fullscreen ? <Maximize /> : <Minimize />}
            </button>
          </Modal.Header>
          <Modal.Body>
            {!this.state.duplicatedValidation && (
              <Row className="mb-3 col-md-12">
                <p className="mandatory-validation">
                  This Profile already exists, your updates cannot be saved.
                </p>
              </Row>
            )}
            {!this.state.validation && (
              <Row className="mb-3 col-md-12">
                <p className="mandatory-validation">
                  Mandatory fields are missing. Saving of the Profile form is
                  not allowed
                </p>
              </Row>
            )}
            <Row>
            <Form.Group>
              <Form.Label
                className={`${this.state.validation ? "normal-title" : "validation-title"
                  } `}
              >
                Name <CircleSign />
              </Form.Label>
              <Form.Control
                className={`${!this.state.validation && "validation-control"} name-input`}
                type="text"
                ref={this.profileName}
                placeholder="Name"
              />
              {!this.state.validation && <p className="p-required">Required</p>}
            </Form.Group>
              <Form.Label className="normal-title font-size-15">
                Access Restriction
              </Form.Label>
              <Form.Group>
                <Form.Label className="normal-title">Agency</Form.Label>
                <MultiSelectDropdown
                  idColumnName="buyingAgencyId"
                  isMulti={true}
                  ref={this.buyingAgencyRef}
                  onChange={(selected) => this.handleFilterChange('agency', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('agency', this.buyingAgencyRef)}
                />
                <Form.Label className="normal-title">Agency Network</Form.Label>
                <MultiSelectDropdown
                  idColumnName="buyingAgencyNetworkId"
                  isMulti={true}
                  ref={this.agencyNetworkRef}
                  onChange={(selected) => this.handleFilterChange('agencyNetwork', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('agencyNetwork', this.agencyNetworkRef)}
                />
                <Form.Label className="normal-title">Zone</Form.Label>
                <MultiSelectDropdown
                  idColumnName="geoElementId"
                  isMulti={true}
                  ref={this.zoneRef}
                  onChange={(selected) => this.handleFilterChange('zone', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('zone', this.zoneRef)}
                />
                <Form.Label className="normal-title">Subzone</Form.Label>
                <MultiSelectDropdown
                  idColumnName="geoElementId"
                  isMulti={true}
                  ref={this.subzoneRef}
                  onChange={(selected) => this.handleFilterChange('subzone', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('subzone', this.subzoneRef)}
                />
                <Form.Label className="normal-title">Country/Region</Form.Label>
                <MultiSelectDropdown
                  idColumnName="geoElementId"
                  isMulti={true}
                  ref={this.countryRef}
                  onChange={(selected) => this.handleFilterChange('country', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('country', this.countryRef)}
                />
                <Form.Label className="normal-title">Maison</Form.Label>
                <MultiSelectDropdown
                  idColumnName="organizationId"
                  isMulti={true}
                  ref={this.maisonRef}
                  onChange={(selected) => this.handleFilterChange('maison', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('maison', this.maisonRef)}
                />
                <Form.Label className="normal-title">Division</Form.Label>
                <MultiSelectDropdown
                  idColumnName="organizationId"
                  isMulti={true}
                  ref={this.divisionRef}
                  onChange={(selected) => this.handleFilterChange('division', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('division', this.divisionRef)}
                />
                <Form.Label className="normal-title">Media</Form.Label>
                <MultiSelectDropdown
                  idColumnName="mediaId"
                  isMulti={true}
                  ref={this.mediaRef}
                  onChange={(selected) => this.handleFilterChange('media', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('media', this.mediaRef)}
                />
                <Form.Label className="normal-title">Currency</Form.Label>
                <MultiSelectDropdown
                  idColumnName="currencyId"
                  ref={this.currencyRef}
                  isMulti={true}
                  onChange={(selected) => this.handleFilterChange('currency', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('currency', this.currencyRef)}
                />
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <ButtonBootstrap
              variant="primary"
              className="btnPrimary"
              onClick={this.onCreateProfile}
            >
              Create Profile
            </ButtonBootstrap>
            <ButtonBootstrap
              variant="secondary"
              className="btnSecondary"
              onClick={this.handleClose}
            >
              Cancel
            </ButtonBootstrap>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showEditModal}
          onHide={this.handleEditClose}
          size="profiles"
          centered
          fullscreen={this.state.fullscreen}
        >
          <Modal.Header closeButton>
            <Modal.Title size="h6">Edit Profile</Modal.Title>
            <button
              type="button"
              class="btn btn-primary admin-btn"
              onClick={this.fullscreenHandler}
            >
              {this.state.fullscreen ? <Maximize /> : <Minimize />}
            </button>
          </Modal.Header>

          <Modal.Body>
            {!this.state.duplicatedValidation && (
              <Row className="mb-3 col-md-12">
                <p className="mandatory-validation">
                  This Profile already exists, your updates cannot be saved.
                </p>
              </Row>
            )}
            {!this.state.editValidation && (
              <Row className="mb-3 col-md-12">
                <p className="mandatory-validation">
                  Mandatory fields are missing. Saving of the Profile form is
                  not allowed
                </p>
              </Row>
            )}
            <Row>
              <Form.Group>
                <Form.Label
                  className={`${this.state.editValidation
                    ? "normal-title"
                    : "validation-title"
                    }`}
                >
                  Name <CircleSign />
                </Form.Label>
                <Form.Control
                  className={`${!this.state.editValidation && "validation-control"
                    } name-input`}
                  type="text"
                  ref={this.profileName}
                  placeholder="Name"
                />
                {!this.state.editValidation && (
                  <p className="p-required">Required</p>
                )}
              </Form.Group>
              <Form.Label className="normal-title font-size-15">
                Access Restriction
              </Form.Label>
              <Form.Group>
                <Form.Label>Agency</Form.Label>
                <MultiSelectDropdown
                  idColumnName="buyingAgencyId"
                  isMulti={true}
                  ref={this.buyingAgencyRef}
                  idsSelected={this.state.selectedFilters.agency}
                  onChange={(selected) => this.handleFilterChange('agency', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('agency', this.buyingAgencyRef)}
                />
                <Form.Label>Agency Network</Form.Label>
                <MultiSelectDropdown
                  idColumnName="buyingAgencyNetworkId"
                  isMulti={true}
                  idsSelected={this.state.selectedFilters.agencynetwork}
                  ref={this.agencyNetworkRef}
                  onChange={(selected) => this.handleFilterChange('agencyNetwork', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('agencyNetwork', this.agencyNetworkRef)}
                />
                <Form.Label>Zone</Form.Label>
                <MultiSelectDropdown
                  idColumnName="geoElementId"
                  isMulti={true}
                  idsSelected={this.state.selectedFilters.zone}
                  onChange={(selected) => this.handleFilterChange('zone', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('zone', this.zoneRef)}
                  ref={this.zoneRef}
                />
                <Form.Label>Subzone</Form.Label>
                <MultiSelectDropdown
                  idColumnName="geoElementId"
                  isMulti={true}
                  idsSelected={this.state.selectedFilters.subzone}
                  ref={this.subzoneRef}
                  onChange={(selected) => this.handleFilterChange('subzone', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('subzone', this.subzoneRef)}
                />
                <Form.Label>Country/Region</Form.Label>
                <MultiSelectDropdown
                  idColumnName="geoElementId"
                  isMulti={true}
                  idsSelected={countries}
                  ref={this.countryRef}
                  onChange={(selected) => this.handleFilterChange('country', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('country', this.countryRef)}
                />
                <Form.Label>Maison</Form.Label>
                <MultiSelectDropdown
                  idColumnName="organizationId"
                  isMulti={true}
                  idsSelected={this.state.selectedFilters.maison}
                  ref={this.maisonRef}
                  onChange={(selected) => this.handleFilterChange('maison', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('maison', this.maisonRef)}
                />
                <Form.Label>Division</Form.Label>
                <MultiSelectDropdown
                  idColumnName="organizationId"
                  isMulti={true}
                  idsSelected={this.state.selectedFilters.division}
                  ref={this.divisionRef}
                  onChange={(selected) => this.handleFilterChange('division', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('division', this.divisionRef)}
                />
                <Form.Label>Media</Form.Label>
                <MultiSelectDropdown
                  idColumnName="mediaId"
                  isMulti={true}
                  idsSelected={this.state.selectedFilters.media}
                  ref={this.mediaRef}
                  onChange={(selected) => this.handleFilterChange('media', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('media', this.mediaRef)}
                />
                <Form.Label>Currency</Form.Label>
                <MultiSelectDropdown
                  ref={this.currencyRef}
                  idColumnName="currencyId"
                  isMulti={true}
                  idsSelected={this.state.selectedFilters.currency}
                  onChange={(selected) => this.handleFilterChange('currency', selected)}
                  handleFilterCriteriaChange={() => this.loadOptionsForCriteria('currency', this.currencyRef)}
                />
                <br />
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <ButtonBootstrap
              variant="primary"
              className="btnPrimary"
              onClick={this.onEditProfile}
            >
              Update Profile
            </ButtonBootstrap>
            <ButtonBootstrap
              variant="secondary"
              className="btnSecondary"
              onClick={this.handleEditClose}
            >
              Cancel
            </ButtonBootstrap>
          </Modal.Footer>
        </Modal>

        <ConfirmationModal
          show={this.state.showConfirmationModal}
          hide={this.closeConfirmationModal}
          doubleCloseModals={this.doubleCloseModals}
          msg="Your updates won't be saved. Are you sure you want to leave this page
          ?"
        />
      </div>
    );
  }
  onShowFilterRowChanged(e) {
    this.setState({
      showFilterRow: e.value,
    });
    this.clearFilter();
  }
  onShowHeaderFilterChanged(e) {
    this.setState({
      showHeaderFilter: e.value,
    });
    this.clearFilter();
  }
  onCurrentFilterChanged(e) {
    this.setState({
      currentFilter: e.value,
    });
  }
  clearFilter() {
    this.dataGrid.clearFilter();
  }
}

export default Profile;
